import colors from '../../../../../public/colors'
 

const styles = theme => {
    const { mode } = theme.palette
    return {
        actionRow: {
            height: '100%',
            justifyContent: 'space-between',
            padding: '16px 24px'
        },
        actionRowContinue: {
            height: '100%',
            justifyContent: 'flex-end',
            padding: '16px 24px'
        },
        button: {
            '&.MuiButton-root': {
                border: '1px solid #006AC3',
                borderRadius: '4px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                height: '40px',
                marginLeft: '10px',
                width: '104px'
            },
            '&:disabled': {
                borderColor: 'rgba(0, 0, 0, 0.12)'
            }
        },
        buttonContainer: {
            '@media screen and (max-width: 320px)': {
                paddingBottom: '20px'
            },
            backgroundColor: colors[mode].primaryBackground,
            display: 'flex',
            justifyContent: 'space-between',
        },
        buttonSkip: {
            '&.MuiButton-root': {
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: colors[mode].primaryText,
                fontFamily: 'Roboto',
                fontFeatureSettings: '"liga" off, "clig" off',
                fontSize: '12px',
                fontWeight: 400,
                height: '32px',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                marginLeft: '10px',
                padding: '8px 16px',
                textTransform: 'uppercase',
            },
            '&:disabled': {
                borderColor: 'rgba(0, 0, 0, 0.12)'
            }
        },
        buttonSubmit: {
            '&.MuiButton-root': {
                backgroundColor: '#FEDF01',
                border: '1px solid #FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: '#003168',
                fontFamily: 'Roboto',
                fontFeatureSettings: '"liga" off, "clig" off',
                fontSize: '12px',
                fontWeight: 400,
                height: '32px',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                marginLeft: '10px',
                padding: '8px 16px',
                textTransform: 'uppercase'
            },
            '&:disabled': {
                borderColor: 'rgba(0, 0, 0, 0.12)',
                opacity: '0.5'
            }
        },
        checkCircle: {
            height: '20px',
            width: '20px'
        },
        content: {
            color: '#0267FF',
            fontSize: '24px',
            fontWeight: '500'
        },
        contentContainer: {
            backgroundColor: 'white',
            borderRadius: '3px',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            color: 'black'
        },
        contentDivider: {
            paddingTop: '25px'
        },
        contentSection: {
            color: 'black',
            fontSize: '20px'
        },
        divider: {
            background: '#FFC72A',
            padding: '2px',
            width: '50px'
        },
        errorText: {
            backgroundColor: colors[mode].primaryBackground,
            marginTop: '0px',
            paddingLeft: '24px'
        },
        fieldsContainer: {
            backgroundColor: colors[mode].primaryBackground,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minHeight: '245px',
            justifyContent: 'space-between',
            padding: '16px 26px'
        },
        loader: {
            height: '100%',
            left: '0',
            position: 'absolute',
            top: '0',
            width: '100%',
            'z-index': '10'
        },
        mfaDesc: {
            color: colors[mode].secondaryText,
            fontSize: '14px'
        },
        mfaListContainer: {
            paddingTop: '20px'
        },
        mfaLogo: {
            color: colors[mode].recoveryIcon,
            height: '20px',
            width: '20px'
        },
        mfaLogoContainer: {
            alignItems: 'flex-start',
            display: 'flex'
        },
        mfaNameContainer: {
            flexDirection: 'column',
        },
        mfaOption: {
            '&:hover': {
                cursor: 'pointer',
                opacity: 0.9
            },
            alignItems: 'center',
            border: `1px solid ${colors[mode].recoveryBorder}`,
            borderRadius: '2px',
            display: 'flex',
            flexDirection: 'row',
            fontFamily: 'Roboto',
            justifyContent: 'space-between',
            marginBottom: '16px',
            padding: '12px 12px',
            width: '90%'
        },
        mfaOptionActive: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            fontFamily: 'Roboto',
            justifyContent: 'space-between',
            marginBottom: '16px',
            padding: '12px 12px',
            width: '90%'
        },
        mfaOptionSelected: {
            backgroundColor: colors[mode].skeletonInsightsBackground,
            border: `1px solid ${colors[mode].recoveryBorder}`,
            color: '#003168',
            fontFamily: 'Roboto',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '24px',
        },
        mfaIconBox: {
            flexDirection: 'row',
            alignItems: 'center',
            display: 'flex',
            marginBottom: '8px'
        },
        mfaSetupTitle: {
            color: 'rgba(0,0,0,0.87)',
            fontSize: '16px',
            height: '24px',
            letterSpacing: '0',
            lineHeight: '24px',
            paddingTop: '20px',
            marginBottom: '10px'
        },
        mfaTitle: {
            color: colors[mode].primaryText,
            fontFeatureSettings: '"liga" off, "clig" off',
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '24px',
            marginLeft: '8px'
        },
        mfaTitleDesc: {
            minHeight: '76px'
        },
        italics: {
            fontStyle: 'italic'
        },
        radio: {
            '&.Mui-checked': {
                color: colors[mode].recoveryIcon
            },
            color: colors[mode].primaryText,
        },
        radioButtonIcon: {
            padding: '16px 18px'
        },
        warningLine: {
            background: colors[mode].primaryBackground,
            color: colors[mode].secondaryText,
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '14px',
            fontStyle: 'italic',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            padding: '32px 24px'
        }
    }
}
export default styles

